import { CHARGE_CDN } from "../../utils/constants";
import qrcode from 'qrcode'
import {
  OrderStatusEnum,
  ReceiptStatusEnum,
  SettleTypeEnum,
  titleEnums
} from "./types";

// 加密银行卡号
export function encryptBankCardNo(bankCardNo: string) {
  if (!bankCardNo) return "";
  return bankCardNo.replace(/(\d{4})\d+(\d{4})$/, "$1 **** $2");
}

// 获取订单文案和颜色
export function getTitleObj(orderDetail: {
  settleType: string; // 结算方式 (01-个人; 02-集团; 03-集团; 04-线下)
  receiptStatus: number; // 到账状态 0-未到账 1-已到账
  orderStatus: string; // 私桩共享订单状态
}) {
  if (orderDetail.settleType === SettleTypeEnum.OFFLINE) {
    return titleEnums.OFFLINE;
  } else if (orderDetail.orderStatus === OrderStatusEnum.WAIT_PAY) {
    return titleEnums.WAIT_PAY;
  } else {
    if (orderDetail.receiptStatus === ReceiptStatusEnum.RECEIPTED) {
      return titleEnums.RECEIPTED;
    } else {
      return titleEnums.TRADE_SUCCESS;
    }
  }
}

export function getRandomItem(list: string[]) {
  if (list.length === 0) {
    return "";
  }
  const randomIndex = Math.floor(Math.random() * list.length);
  return list[randomIndex];
}

// 生成海报
export const generatePoster = (stationData: any): Promise<string> => {
  // 绘制文本
  const drawText = (context, text, color, x, y, font) => {
    context.font = font;
    context.fillStyle = color;
    context.fillText(text, x, y);
  }

  return new Promise(async (resolve, reject) => {
    const canvas = document.createElement('canvas');
    const ratio = (window.devicePixelRatio || 1) + 1;
    canvas.width = 590 * ratio;
    canvas.height = 864 * ratio;
    const ctx = canvas.getContext("2d") as CanvasRenderingContext2D;
    ctx.scale(ratio, ratio)

    // 首先清空画布
    ctx.clearRect(0, 0, 590, 864);
    ctx.save();

    const bgImage = new Image();
    bgImage.crossOrigin = 'anonymous';
    bgImage.onerror = reject;
    await new Promise((resolve) => {
      bgImage.onload = resolve
      bgImage.src = `${CHARGE_CDN}/sharing/pile_sharing_poster_v2.jpg`
    })

    const qrCodeImg = new Image();
    await qrcode.toDataURL(
      stationData?.operationDto?.stationQrCode || 'https://xiaopeng.com',
      { margin: 0 },
      (err, res) => {
        if (err) {
          console.log('qrcode.toDataURL error', err)
          return
        }
        qrCodeImg.src = res

        qrCodeImg.onload = () => {
          // 缩放后单位像素
          const unitPx = canvas.width / ratio / 590

          ctx.drawImage(bgImage, 0, 0, 590, 864);
          console.log(res, 'qrCodeImg')
          ctx.drawImage(qrCodeImg, unitPx * 54, unitPx * 690, unitPx * 134, unitPx * 134);
          drawText(ctx, '扫码查看充电站', '#ffffff', unitPx * 68, unitPx * 850, '16px PingFang SC');
          drawText(ctx, '「小鹏家充已开启共享功能」', '#ffffff', unitPx * 212, unitPx * 718, '24px PingFang SC');
          drawText(ctx, `${stationData?.baseDto?.stationName}`, '#ffffff', unitPx * 226, unitPx * 766, '22px PingFang SC');

          // 地址超过11个字符需要换行
          const addr = stationData?.baseDto?.stationAddr
          const addrColor = 'rgba(255, 255, 255, 0.6)'
          const addrFont = '22px PingFang SC'
          if (addr && addr.length > 11) {
            const strLength = addr.length
            const firstRowText = addr.substring(0, 11)
            const secondRowText = strLength > 25 ? `${addr.substring(11, 25)}...` : addr.substring(11)
            drawText(ctx, `地址：${firstRowText}`, addrColor, unitPx * 226, unitPx * 810, addrFont);
            drawText(ctx, `${secondRowText}`, addrColor, unitPx * 226, unitPx * 838, addrFont);
          } else {
            drawText(ctx, `地址：${addr}`, addrColor, unitPx * 226, unitPx * 810, addrFont);
          }
          resolve(canvas.toDataURL(`image/jpeg`, 0.4))
        }
      }
    )
  })
}
